/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Icon, Image, Text, View } from "@aws-amplify/ui-react";
export default function SayGoodbye(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="68px"
      direction="row"
      width="unset"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-end"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "SayGoodbye")}
      {...rest}
    >
      <Flex
        gap="42px"
        direction="column"
        width="552px"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464709")}
      >
        <Flex
          gap="49px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464704")}
        >
          <Flex
            gap="20px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464706")}
          >
            <Flex
              padding="0px 0px 0px 0px"
              width="460px"
              height="120px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              shrink="0"
              position="relative"
              {...getOverrideProps(overrides, "Title753724296")}
            >
              <Text
                fontFamily="Inter"
                fontSize="40px"
                fontWeight="700"
                color="rgba(11,20,31,1)"
                lineHeight="60px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="460px"
                height="unset"
                gap="unset"
                alignItems="unset"
                position="absolute"
                top="0px"
                left="0px"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="Say Good-Bye to the Endless Drudgery of:"
                {...getOverrideProps(
                  overrides,
                  "Say Good-Bye to the Endless Drudgery of:"
                )}
              ></Text>
            </Flex>
            <Flex
              gap="14px"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="flex-start"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 1160464105")}
            >
              <Flex
                gap="16px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464114753724299")}
              >
                <View
                  width="28px"
                  height="28px"
                  display="block"
                  gap="unset"
                  alignItems="unset"
                  justifyContent="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "Frame 1160464705753724300")}
                >
                  <View
                    padding="0px 0px 0px 0px"
                    width="16.21px"
                    height="16.21px"
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="5.89px"
                    left="5.89px"
                    {...getOverrideProps(
                      overrides,
                      "Group 1160463947753724301"
                    )}
                  >
                    <Icon
                      width="16.21px"
                      height="16.21px"
                      viewBox={{
                        minX: 0,
                        minY: 0,
                        width: 16.210525512695312,
                        height: 16.210525512695312,
                      }}
                      paths={[
                        {
                          d: "M17.0944 0.883883L17.9783 0L16.2105 -1.76777L15.3266 -0.883883L17.0944 0.883883ZM-0.883883 15.3266L-1.76777 16.2105L0 17.9783L0.883883 17.0944L-0.883883 15.3266ZM15.3266 -0.883883L-0.883883 15.3266L0.883883 17.0944L17.0944 0.883883L15.3266 -0.883883Z",
                          stroke: "rgba(212,0,0,1)",
                          fillRule: "nonzero",
                          strokeLinejoin: "round",
                          strokeWidth: 2,
                        },
                      ]}
                      display="block"
                      gap="unset"
                      alignItems="unset"
                      justifyContent="unset"
                      position="absolute"
                      top="0%"
                      bottom="0%"
                      left="0%"
                      right="0%"
                      {...getOverrideProps(overrides, "Vector753724302")}
                    ></Icon>
                    <Icon
                      width="16.21px"
                      height="16.21px"
                      viewBox={{
                        minX: 0,
                        minY: 0,
                        width: 16.210525512695312,
                        height: 16.210525512695312,
                      }}
                      paths={[
                        {
                          d: "M0.883883 -0.883883L0 -1.76777L-1.76777 0L-0.883883 0.883883L0.883883 -0.883883ZM15.3266 17.0944L16.2105 17.9783L17.9783 16.2105L17.0944 15.3266L15.3266 17.0944ZM-0.883883 0.883883L15.3266 17.0944L17.0944 15.3266L0.883883 -0.883883L-0.883883 0.883883Z",
                          stroke: "rgba(212,0,0,1)",
                          fillRule: "nonzero",
                          strokeLinejoin: "round",
                          strokeWidth: 2,
                        },
                      ]}
                      display="block"
                      gap="unset"
                      alignItems="unset"
                      justifyContent="unset"
                      position="absolute"
                      top="0%"
                      bottom="0%"
                      left="0%"
                      right="0%"
                      {...getOverrideProps(overrides, "Vector753724303")}
                    ></Icon>
                  </View>
                </View>
                <Text
                  fontFamily="Inter"
                  fontSize="18px"
                  fontWeight="400"
                  color="rgba(11,20,31,1)"
                  lineHeight="28px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Managing The Submission Process"
                  {...getOverrideProps(
                    overrides,
                    "Managing The Submission Process"
                  )}
                ></Text>
              </Flex>
              <Icon
                width="507px"
                height="0px"
                viewBox={{ minX: 0, minY: 0, width: 507, height: 1 }}
                paths={[
                  {
                    d: "M0 0.5L507 0.5L507 -0.5L0 -0.5L0 0.5Z",
                    stroke: "rgba(221,221,221,1)",
                    fillRule: "nonzero",
                    strokeWidth: 1,
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                {...getOverrideProps(overrides, "Line 3753724305")}
              ></Icon>
              <Flex
                gap="16px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="flex-start"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464115753724306")}
              >
                <View
                  width="28px"
                  height="28px"
                  display="block"
                  gap="unset"
                  alignItems="unset"
                  justifyContent="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "Frame 1160464705753724307")}
                >
                  <View
                    padding="0px 0px 0px 0px"
                    width="16.21px"
                    height="16.21px"
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="5.89px"
                    left="5.89px"
                    {...getOverrideProps(
                      overrides,
                      "Group 1160463947753724308"
                    )}
                  >
                    <Icon
                      width="16.21px"
                      height="16.21px"
                      viewBox={{
                        minX: 0,
                        minY: 0,
                        width: 16.210525512695312,
                        height: 16.210525512695312,
                      }}
                      paths={[
                        {
                          d: "M17.0944 0.883883L17.9783 0L16.2105 -1.76777L15.3266 -0.883883L17.0944 0.883883ZM-0.883883 15.3266L-1.76777 16.2105L0 17.9783L0.883883 17.0944L-0.883883 15.3266ZM15.3266 -0.883883L-0.883883 15.3266L0.883883 17.0944L17.0944 0.883883L15.3266 -0.883883Z",
                          stroke: "rgba(212,0,0,1)",
                          fillRule: "nonzero",
                          strokeLinejoin: "round",
                          strokeWidth: 2,
                        },
                      ]}
                      display="block"
                      gap="unset"
                      alignItems="unset"
                      justifyContent="unset"
                      position="absolute"
                      top="0%"
                      bottom="0%"
                      left="0%"
                      right="0%"
                      {...getOverrideProps(overrides, "Vector753724309")}
                    ></Icon>
                    <Icon
                      width="16.21px"
                      height="16.21px"
                      viewBox={{
                        minX: 0,
                        minY: 0,
                        width: 16.210525512695312,
                        height: 16.210525512695312,
                      }}
                      paths={[
                        {
                          d: "M0.883883 -0.883883L0 -1.76777L-1.76777 0L-0.883883 0.883883L0.883883 -0.883883ZM15.3266 17.0944L16.2105 17.9783L17.9783 16.2105L17.0944 15.3266L15.3266 17.0944ZM-0.883883 0.883883L15.3266 17.0944L17.0944 15.3266L0.883883 -0.883883L-0.883883 0.883883Z",
                          stroke: "rgba(212,0,0,1)",
                          fillRule: "nonzero",
                          strokeLinejoin: "round",
                          strokeWidth: 2,
                        },
                      ]}
                      display="block"
                      gap="unset"
                      alignItems="unset"
                      justifyContent="unset"
                      position="absolute"
                      top="0%"
                      bottom="0%"
                      left="0%"
                      right="0%"
                      {...getOverrideProps(overrides, "Vector753724310")}
                    ></Icon>
                  </View>
                </View>
                <Text
                  fontFamily="Inter"
                  fontSize="18px"
                  fontWeight="400"
                  color="rgba(11,20,31,1)"
                  lineHeight="28px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="468px"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Stressful Resume Sorting"
                  {...getOverrideProps(overrides, "Stressful Resume Sorting")}
                ></Text>
              </Flex>
              <Icon
                width="507px"
                height="0px"
                viewBox={{ minX: 0, minY: 0, width: 507, height: 1 }}
                paths={[
                  {
                    d: "M0 0.5L507 0.5L507 -0.5L0 -0.5L0 0.5Z",
                    stroke: "rgba(221,221,221,1)",
                    fillRule: "nonzero",
                    strokeWidth: 1,
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                {...getOverrideProps(overrides, "Line 2753724312")}
              ></Icon>
              <Flex
                gap="16px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="flex-start"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464116753724313")}
              >
                <View
                  width="28px"
                  height="28px"
                  display="block"
                  gap="unset"
                  alignItems="unset"
                  justifyContent="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "Frame 1160464705753724314")}
                >
                  <View
                    padding="0px 0px 0px 0px"
                    width="16.21px"
                    height="16.21px"
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="5.89px"
                    left="5.89px"
                    {...getOverrideProps(
                      overrides,
                      "Group 1160463947753724315"
                    )}
                  >
                    <Icon
                      width="16.21px"
                      height="16.21px"
                      viewBox={{
                        minX: 0,
                        minY: 0,
                        width: 16.210525512695312,
                        height: 16.210525512695312,
                      }}
                      paths={[
                        {
                          d: "M17.0944 0.883883L17.9783 0L16.2105 -1.76777L15.3266 -0.883883L17.0944 0.883883ZM-0.883883 15.3266L-1.76777 16.2105L0 17.9783L0.883883 17.0944L-0.883883 15.3266ZM15.3266 -0.883883L-0.883883 15.3266L0.883883 17.0944L17.0944 0.883883L15.3266 -0.883883Z",
                          stroke: "rgba(212,0,0,1)",
                          fillRule: "nonzero",
                          strokeLinejoin: "round",
                          strokeWidth: 2,
                        },
                      ]}
                      display="block"
                      gap="unset"
                      alignItems="unset"
                      justifyContent="unset"
                      position="absolute"
                      top="0%"
                      bottom="0%"
                      left="0%"
                      right="0%"
                      {...getOverrideProps(overrides, "Vector753724316")}
                    ></Icon>
                    <Icon
                      width="16.21px"
                      height="16.21px"
                      viewBox={{
                        minX: 0,
                        minY: 0,
                        width: 16.210525512695312,
                        height: 16.210525512695312,
                      }}
                      paths={[
                        {
                          d: "M0.883883 -0.883883L0 -1.76777L-1.76777 0L-0.883883 0.883883L0.883883 -0.883883ZM15.3266 17.0944L16.2105 17.9783L17.9783 16.2105L17.0944 15.3266L15.3266 17.0944ZM-0.883883 0.883883L15.3266 17.0944L17.0944 15.3266L0.883883 -0.883883L-0.883883 0.883883Z",
                          stroke: "rgba(212,0,0,1)",
                          fillRule: "nonzero",
                          strokeLinejoin: "round",
                          strokeWidth: 2,
                        },
                      ]}
                      display="block"
                      gap="unset"
                      alignItems="unset"
                      justifyContent="unset"
                      position="absolute"
                      top="0%"
                      bottom="0%"
                      left="0%"
                      right="0%"
                      {...getOverrideProps(overrides, "Vector753724317")}
                    ></Icon>
                  </View>
                </View>
                <Text
                  fontFamily="Inter"
                  fontSize="18px"
                  fontWeight="400"
                  color="rgba(11,20,31,1)"
                  lineHeight="28px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="479px"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Corresponding With Those Who Don’t Fit"
                  {...getOverrideProps(
                    overrides,
                    "Corresponding With Those Who Don\u2019t Fit"
                  )}
                ></Text>
              </Flex>
            </Flex>
          </Flex>
          <Flex
            gap="20px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464707")}
          >
            <Flex
              padding="0px 0px 0px 0px"
              width="460px"
              height="60px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              shrink="0"
              position="relative"
              {...getOverrideProps(overrides, "Title753724320")}
            >
              <Text
                fontFamily="Inter"
                fontSize="40px"
                fontWeight="700"
                color="rgba(11,20,31,1)"
                lineHeight="60px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="460px"
                height="unset"
                gap="unset"
                alignItems="unset"
                position="absolute"
                top="0px"
                left="0px"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="Say Hello To: "
                {...getOverrideProps(overrides, "Say Hello To:")}
              ></Text>
            </Flex>
            <Flex
              gap="14px"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="flex-start"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 1160464106")}
            >
              <Flex
                gap="16px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464114753724323")}
              >
                <View
                  width="29.5px"
                  height="29.5px"
                  {...getOverrideProps(overrides, "Check753724324")}
                ></View>
                <Text
                  fontFamily="Inter"
                  fontSize="18px"
                  fontWeight="400"
                  color="rgba(11,20,31,1)"
                  lineHeight="28px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Click - Sort - Done - SMILE!"
                  {...getOverrideProps(
                    overrides,
                    "Click - Sort - Done - SMILE!"
                  )}
                ></Text>
              </Flex>
              <Icon
                width="507px"
                height="0px"
                viewBox={{ minX: 0, minY: 0, width: 507, height: 1 }}
                paths={[
                  {
                    d: "M0 0.5L507 0.5L507 -0.5L0 -0.5L0 0.5Z",
                    stroke: "rgba(221,221,221,1)",
                    fillRule: "nonzero",
                    strokeWidth: 1,
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                {...getOverrideProps(overrides, "Line 3753724326")}
              ></Icon>
              <Flex
                gap="16px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="flex-start"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464115753724327")}
              >
                <View
                  width="29.5px"
                  height="29.5px"
                  {...getOverrideProps(overrides, "Check753724328")}
                ></View>
                <Text
                  fontFamily="Inter"
                  fontSize="18px"
                  fontWeight="400"
                  color="rgba(11,20,31,1)"
                  lineHeight="28px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="468px"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Happier Candidates"
                  {...getOverrideProps(overrides, "Happier Candidates")}
                ></Text>
              </Flex>
              <Icon
                width="507px"
                height="0px"
                viewBox={{ minX: 0, minY: 0, width: 507, height: 1 }}
                paths={[
                  {
                    d: "M0 0.5L507 0.5L507 -0.5L0 -0.5L0 0.5Z",
                    stroke: "rgba(221,221,221,1)",
                    fillRule: "nonzero",
                    strokeWidth: 1,
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                {...getOverrideProps(overrides, "Line 2753724330")}
              ></Icon>
              <Flex
                gap="16px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="flex-start"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464116753724331")}
              >
                <View
                  width="29.5px"
                  height="29.5px"
                  {...getOverrideProps(overrides, "Check753724332")}
                ></View>
                <Text
                  fontFamily="Inter"
                  fontSize="18px"
                  fontWeight="400"
                  color="rgba(11,20,31,1)"
                  lineHeight="28px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="479px"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Satisfying, Long-Term Results "
                  {...getOverrideProps(
                    overrides,
                    "Satisfying, Long-Term Results\u00A0"
                  )}
                ></Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <Flex
          gap="0"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="center"
          alignItems="center"
          shrink="0"
          position="relative"
          borderRadius="4px"
          padding="16px 24px 16px 24px"
          backgroundColor="rgba(204,164,59,1)"
          {...getOverrideProps(overrides, "Button")}
        >
          <Text
            fontFamily="Inter"
            fontSize="16px"
            fontWeight="700"
            color="rgba(255,255,255,1)"
            lineHeight="24px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Speak With One Of Our ikimy Experts"
            {...getOverrideProps(overrides, "label")}
          ></Text>
        </Flex>
      </Flex>
      <Flex
        gap="-119px"
        direction="row"
        width="520px"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464791")}
      >
        <Image
          width="520px"
          height="660px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          position="relative"
          borderRadius="11px"
          padding="0px 0px 0px 0px"
          objectFit="unset"
          {...getOverrideProps(overrides, "Image")}
        ></Image>
        <Flex
          padding="0px 0px 0px 0px"
          width="261px"
          height="159px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          position="relative"
          {...getOverrideProps(overrides, "Item")}
        >
          <Flex
            gap="9.957082748413086px"
            direction="column"
            width="261px"
            height="159px"
            justifyContent="flex-start"
            alignItems="flex-start"
            overflow="hidden"
            position="absolute"
            top="0px"
            left="0px"
            border="0.47px SOLID rgba(200,211,223,1)"
            boxShadow="0px 2.6996467113494873px 2.6996467113494873px rgba(0, 0, 0, 0.25)"
            borderRadius="10.79858684539795px"
            padding="0px 0px 0px 0px"
            backgroundColor="rgba(255,255,255,1)"
            {...getOverrideProps(overrides, "Frame 1160464556")}
          >
            <Image
              width="267px"
              height="164.5px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              objectFit="cover"
              {...getOverrideProps(overrides, "image 18")}
            ></Image>
          </Flex>
        </Flex>
        <Image
          width="240px"
          height="58px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          objectFit="cover"
          {...getOverrideProps(overrides, "image 19")}
        ></Image>
      </Flex>
    </Flex>
  );
}
